import React from "react";
import Tooltips from '@mui/material/Tooltip';




{/* <Tooltip
  TooltipText="Text"
  Tooltip={<InfoRoundedIcon />}
/> */}


function Tooltip(props) {



  return (
    <div className="PM_Tooltip">

      <Tooltips
        title={props.TooltipText}
        placement="top"
        arrow
      >
        <div>{props.Tooltip}</div>
      </Tooltips>

    </div>
  );
}


export default Tooltip;

